import {
    DataDimensionValue,
    DataDimensionValueType,
} from "./dimension.data.value";
import type { DataDimensionValueConfig } from "./dimension.data.value.factory";

export interface DataDimensionValueNoneConfig {
    type: DataDimensionValueType.NONE;
}

export class DataDimensionValueNone extends DataDimensionValue {
    constructor(dimensionId: string, config: DataDimensionValueConfig) {
        super(dimensionId, config);
        this.config = config;
    }

    type = DataDimensionValueType.NONE;
    config: DataDimensionValueConfig;

    setValue(): void {
        return;
    }

    protected handler(): string {
        return "none";
    }
}
